import React from 'react';
export function HowItWorks() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const steps = [{
    number: '1',
    title: 'Request a Walkthrough',
    description: 'We tour your facility and learn exactly what you need.'
  }, {
    number: '2',
    title: 'Get Your Custom Plan',
    description: 'Receive a transparent quote with no hidden fees.'
  }, {
    number: '3',
    title: 'Enjoy a Spotless Space',
    description: 'Sit back while our team delivers consistent, reliable results.'
  }];
  return <section id="how-it-works" className="bg-[#F5F7FA] py-20 px-4 sm:px-6 lg:px-8" data-id="element-161">
      <div className="max-w-7xl mx-auto" data-id="element-162">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-16" data-id="element-163">
          Getting Started Is Easy
        </h2>

        {/* Steps Container */}
        <div className="relative" data-id="element-164">
          {/* Dashed Line (Desktop Only) */}
          <div className="hidden md:block absolute top-8 left-1/2 -translate-x-1/2 w-2/3 border-t-2 border-dashed border-[#0E7C86]/30" data-id="element-165" />

          {/* Steps */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-12 md:gap-8 lg:gap-16" data-id="element-166">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center relative z-10" data-id="element-167">
                {/* Number Circle */}
                <div className="w-16 h-16 rounded-full bg-[#0E7C86] text-white text-2xl font-bold flex items-center justify-center shadow-lg" data-id="element-168">
                  {step.number}
                </div>
                {/* Title */}
                <h3 className="font-semibold text-xl text-gray-900 mt-4" data-id="element-169">
                  {step.title}
                </h3>
                {/* Description */}
                <p className="text-gray-600 mt-2 max-w-xs" data-id="element-170">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12" data-id="element-171">
          <button onClick={() => scrollToSection('contact')} className="bg-[#6BBF3B] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#5aa832] transition-colors text-lg" data-id="element-172">
            Schedule Your Walkthrough
          </button>
        </div>
      </div>
    </section>;
}